import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Container } from "reactstrap";
import AllReports from "./AllReports";
import resubmitClaims from "../../../assets/icon/resubmit-claims.svg";
import favIcon from "../../../assets/icon/fav-icon.svg";
import billingIcon from "../../../assets/icon/billing.svg";
import newAuditIcon from "../../../assets/icon/new-audit.svg";
import financeIcon from "../../../assets/icon/finance.svg";
import invIcon from "../../../assets/icon/inv-report-icon.svg";
import operationIcon from "../../../assets/icon/operation.svg";
import favoriteIcon from "../../../assets/reports/star.svg";

const ReportsDashboard = () => {
  const [key, setKey] = useState("allreports");
  const [active, setActive] = useState("tab-1");

  const handleClick = (e) => {
    setActive(e.target.id);
  };

  return (
    <Container fluid className="bin_info rounded p-3 pt-0 pb-0">
      <div className="btn-container">
        <div className="btncroll">
          <button
            className={`btn-tab ${active === "tab-1" ? "active" : ""}`}
            id="tab-1"
            onClick={handleClick}
          >
            <img src={resubmitClaims} alt="" style={{ marginRight: "10px" }} />
            All Reports
          </button>
          <button
            id="tab-2"
            className={`btn-tab ${active === "tab-2" ? "active" : ""}`}
            onClick={handleClick}
          >
            {" "}
            <img src={favIcon} alt="" style={{ marginRight: "10px" }} />
            Favorites
          </button>
          <button
            className={`btn-tab ${active === "tab-3" ? "active" : ""}`}
            id="tab-3"
            onClick={handleClick}
          >
            <img src={billingIcon} alt="" style={{ marginRight: "10px" }} />
            Billing
          </button>
          <button
            className={`btn-tab ${active === "tab-4" ? "active" : ""}`}
            id="tab-4"
            onClick={handleClick}
          >
            <img src={newAuditIcon} alt="" style={{ marginRight: "10px" }} />
            Compliance & Audit
          </button>
          <button
            className={`btn-tab ${active === "tab-5" ? "active" : ""}`}
            id="tab-5"
            onClick={handleClick}
          >
            <img src={financeIcon} alt="" style={{ marginRight: "10px" }} />
            Finance
          </button>
          <button
            className={`btn-tab ${active === "tab-6" ? "active" : ""}`}
            id="tab-6"
            onClick={handleClick}
          >
            <img src={invIcon} alt="" style={{ marginRight: "10px" }} />
            Inventory
          </button>
          <button
            className={`btn-tab ${active === "tab-7" ? "active" : ""}`}
            id="tab-7"
            onClick={handleClick}
          >
            <img src={operationIcon} alt="" style={{ marginRight: "10px" }} />
            Operations
          </button>
        </div>
      </div>
      <div className="tab-content">
        <div className={`tab-page ${active === "tab-1" ? "active" : ""}`}>
          <AllReports />
        </div>
        <div className={`tab-page ${active === "tab-2" ? "active" : ""}`}>
          In Developement
        </div>
      </div>
    </Container>
  );
};

export default ReportsDashboard;
